import { RootEpic } from 'typesafe-actions';

import { createGetEpic } from '../utils';
import {
  ContractPackageDetailsRequestParams,
  getContractPackageDetailsAsync,
} from './actions';
import { forkJoin, Observable } from 'rxjs';

export const loadContractDetailsAsync: RootEpic = (
  action$,
  state$,
  {
    getContractPackageInfoSubscription,
    getContractPackageCep18TokenListSubscription,
    getPaginatedContractPackageOwnedNftsSubscriptions,
    getPaginatedContractsCep18TokenListSubscription,
    getPaginatedContractPackageNftOwnersSubscriptions,
    getContractPackageContractsInfoSubscription,
  }
) =>
  createGetEpic<ContractPackageDetailsRequestParams>(
    action$,
    getContractPackageDetailsAsync,
    (params: ContractPackageDetailsRequestParams): Observable<any> =>
      forkJoin([
        getContractPackageInfoSubscription(params.contractPackageInfoParams),
        getContractPackageCep18TokenListSubscription(params.holdersParams),
        getPaginatedContractPackageOwnedNftsSubscriptions(
          params.nftTokensParams
        ),
        getPaginatedContractsCep18TokenListSubscription(
          params.cep18TokensParams
        ),
        getPaginatedContractPackageNftOwnersSubscriptions(params.ownersParams),
        getContractPackageContractsInfoSubscription(
          params.contractVersionParams
        ),
      ])
  );
